import React from "react";
import { Provider } from "react-redux";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";

import { persistor, store } from "redux-store/store";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";

import "./index.css";
import {
  FIREBASE_apiKey,
  FIREBASE_authDomain,
  FIREBASE_databaseURL,
  FIREBASE_measurementId,
  FIREBASE_messagingSenderId,
  FIREBASE_projectId,
  FIREBASE_storageBucket,
  REACT_APP_FIREBASE_appId,
} from "AppConfig";
import { toast } from "react-toastify";

if ("serviceWorker" in navigator) {
  const firebaseConfig = {
    apiKey: FIREBASE_apiKey,
    authDomain: FIREBASE_authDomain,
    databaseURL: FIREBASE_databaseURL,
    projectId: FIREBASE_projectId,
    storageBucket: FIREBASE_storageBucket,
    messagingSenderId: FIREBASE_messagingSenderId,
    appId: REACT_APP_FIREBASE_appId,
    measurementId: FIREBASE_measurementId,
  };

  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      return navigator.serviceWorker.ready;
    })
    .then((registration) => {
      if (registration.active) {
        registration.active.postMessage({
          type: "SET_CONFIG",
          firebaseConfig,
        });
      }
    })
    .catch((error) => {
      toast.error("Service worker registration failed");
    });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<h1>Loading</h1>} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
